import { Stack, Box, Paper, Button, Link, Typography, Chip, Divider, FormControl, InputLabel, Select, MenuItem, Tooltip } from "@mui/material";
import { ClockHistory } from "react-bootstrap-icons";
import TitlePaper from "@components/atoms/TitlePaper/TitlePaper";
import { Link as ReactRouterLink } from "react-router-dom";
import { grey } from "@mui/material/colors";
import { IRemisionPaymentInfoUI } from "src/types/molecules";
import Salary from "@components/atoms/Salary/Salary";
import { getCurrency, REMISION_STATE_CHIP } from "@utils/utils";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import InputText from "@components/atoms/InputText/InputText";
import MoreOptions from "../MoreOptions/MoreOptions";
import MyButton from "@components/atoms/MyButton/MyButton";
const RemisionPaymentInfoUI = ({
  remisionId,
  state,
  total,
  showError,
  closeError,
  errorMessage,
  showPayDialog,
  setShowPayDialog,
  showDeleteDialog,
  setShowDeleteDialog,
  showNameDialog,
  setShowNameDialog,
  register,
  pay,
  registerName,
  editName,
  isLoading,
  moreOptions,
  deleteRemision,
  employeeCode,
  setEmployeeCode,
  applicant,
  setApplicant,
  handleClosePayDialog,
  handleCloseNameDialog,
  handleCloseDeleteDialog,
  paymentMethod,
  setPaymentMethod,
  onViewStateHistory
}: IRemisionPaymentInfoUI) => {
  const classes = {
    transacPaper: {
      position: "relative",
      width: 400,
      padding: "24px",
      height: "fit-content"
    },
    chipStatus: {
      fontWeight: 600,
      transform: "scale(.9)",
      marginLeft: 1
    }
  };
  return <>
      <Paper elevation={12} sx={classes.transacPaper}>
        <MoreOptions options={moreOptions} />
        <TitlePaper title="Resumen" subtitle="Estado actual de la remisión y opciones disponibles" />
        <Stack direction={"row"} alignItems={"center"} marginTop={1.5}>
          <Typography color={grey[500]}>Estado</Typography>
          <Chip color={REMISION_STATE_CHIP[state]?.color ?? "default"} sx={classes.chipStatus} label={REMISION_STATE_CHIP[state]?.label ?? state} data-testid="remision-state-chip" />
          <Tooltip title="Ver historial de estados" placement="top">
            <MyButton aria-label="Ver historial de estados" onClick={onViewStateHistory}>
              <ClockHistory size={18} />
            </MyButton>
          </Tooltip>
        </Stack>
        <Salary label="Total a pagar" value={getCurrency(total)} weight={800} />
        <Divider sx={{
        mt: 1
      }} />
        {state === "Creado" && <>
            <Button onClick={() => setShowPayDialog(true)} fullWidth sx={{
          marginTop: 1
        }}>
              Pagar completo
            </Button>
            <Link component={ReactRouterLink} to={`/remisiones/${remisionId}/devoluciones`}>
              <Button fullWidth variant="outlined" sx={{
            marginTop: 1
          }}>
                Devolución
              </Button>
            </Link>
          </>}
      </Paper>

      {/* Pay dialog */}
      <ConfirmDialog open={showPayDialog} cancelAction={handleClosePayDialog} confirmAction={pay} title="Pagar remisión completa" subtitle="" message={`Total: ${getCurrency(total)}`} cancelLabel="Cancelar" confirmLabel="Pagar completo" contentRender={<Box marginTop={1}>
            <InputText label="Código de empleado" name="employeeCode" placeholder="Ingresa tu código de empleado *" register={register("employeeCode", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setEmployeeCode(e.target.value),
        value: employeeCode || "",
        required: true
      })} disabled={isLoading} sx={{
        mb: 2
      }} autoFocus={true} type="password" />
            <InputText label="Solicitante" name="applicant" placeholder="Ingresa el nombre del solicitante" register={register("applicant", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setApplicant(e.target.value),
        value: applicant || ""
      })} disabled={isLoading} sx={{
        mb: 2
      }} />
            <FormControl fullWidth sx={{
        mb: 2
      }} disabled={isLoading}>
              <InputLabel id="remision-payment-method-label">
                Método de pago
              </InputLabel>
              <Select labelId="remision-payment-method-label" value={paymentMethod} label="Método de pago" onChange={e => setPaymentMethod(Number(e.target.value))}>
                <MenuItem value={0}>Efectivo</MenuItem>
                <MenuItem value={1}>Transferencia</MenuItem>
              </Select>
            </FormControl>
          </Box>} disabled={!employeeCode.trim() || isLoading} withEnter={true} />

      {/* Delete dialog */}
      <ConfirmDialog open={showDeleteDialog} cancelAction={handleCloseDeleteDialog} confirmAction={deleteRemision} title="Eliminar remisión" subtitle="Ingresa tu código de empleado *" message="Por favor, ingresa tu código de empleado * para confirmar la eliminación de la remisión." cancelLabel="No eliminar" confirmLabel="Sí, eliminar" contentRender={<Box sx={{
      mt: 2
    }}>
            <InputText label="Código de empleado" name="employeeCode" placeholder="Ingresa tu código de empleado *" register={register("employeeCode", {
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => setEmployeeCode(e.target.value),
        value: employeeCode,
        required: true
      })} type="password" disabled={isLoading} sx={{
        mb: 2
      }} />
          </Box>} disabled={!employeeCode.trim() || isLoading} withEnter={true} />

      {/* Edit name dialog */}
      <ConfirmDialog open={showNameDialog} cancelAction={handleCloseNameDialog} confirmAction={editName} title="Editar nombre" subtitle="" message="Ingresa un nuevo nombre para la remisión" cancelLabel="Cancelar" confirmLabel="Editar" withEnter={true} withEscape={true} contentRender={<Box marginTop={1}>
            <InputText label="Nuevo nombre" name="name" register={registerName("name", {
        required: true
      })} disabled={isLoading} autoFocus={true} sx={{
        mb: 2
      }} />
            <InputText label="Código de empleado" name="employeeCode" placeholder="Ingresa tu código de empleado *" register={registerName("employeeCode", {
        required: true
      })} disabled={isLoading} sx={{
        mb: 2
      }} type="password" />
          </Box>} disabled={isLoading} />

      <ErrorAlert open={showError} onClose={closeError} message={errorMessage} />
    </>;
};
export default RemisionPaymentInfoUI;